import { defineMessages } from 'react-intl';
const COMPUTER_TITLE_MESSAGES = defineMessages({
    '/computer/tasks': {
        defaultMessage: 'Perplexity Computer Sessions',
        description: 'Document title for the Perplexity Computer tasks list page',
        id: '23f0822ad7',
    },
    '/computer/automations': {
        defaultMessage: 'Perplexity Computer Automations',
        description: 'Document title for the Perplexity Computer automations page',
        id: '1814e8a78c',
    },
    '/computer/new': {
        defaultMessage: 'Start a Session - Perplexity Computer',
        description: 'Document title for the Perplexity Computer new task page',
        id: '7bb7fe6cf1',
    },
    '/computer/artifacts': {
        defaultMessage: 'Perplexity Computer Artifacts',
        description: 'Document title for the Perplexity Computer artifacts page',
        id: '5904dbc16f',
    },
    '/computer/skills': {
        defaultMessage: 'Perplexity Computer Skills',
        description: 'Document title for the Perplexity Computer skills list page',
        id: 'ea496c946e',
    },
    '/computer/plugins': {
        defaultMessage: 'Perplexity Computer Plugins',
        description: 'Document title for the Perplexity Computer plugins page',
        id: 'b3b3cbff0d',
    },
    '/computer/workflows': {
        defaultMessage: 'Perplexity Computer Workflows',
        description: 'Document title for the Perplexity Computer workflows page',
        id: 'a153d4a504',
    },
    '/computer/memory': {
        defaultMessage: 'Perplexity Computer Memory',
        description: 'Document title for the Perplexity Computer memory page',
        id: '1271005a24',
    },
    '/computer/connectors': {
        defaultMessage: 'Perplexity Computer Connectors',
        description: 'Document title for the Perplexity Computer connectors page',
        id: '77514092b6',
    },
    '/computer/credentials-vault': {
        defaultMessage: 'Perplexity Computer Credential vault',
        description: 'Document title for the Perplexity Computer Credential vault page',
        id: 'af12728990',
    },
});
const COMPUTER_DESCRIPTION_MESSAGES = defineMessages({
    computerPageDescriptionMessage: {
        defaultMessage: 'Everything AI can do, Perplexity Computer does for you. Computer works on any task: building websites, editing documents, analyzing data, and automating repetitive work.',
        description: 'Description metadata for Perplexity Computer pages',
        id: '9105dcc419',
    },
    computerTaskDescriptionMessage: {
        defaultMessage: 'Built with Perplexity Computer. Computer works on any task: building websites, editing documents, analyzing data, and automating repetitive work.',
        description: 'Description metadata for Perplexity Computer task pages',
        id: '36425342fe',
    },
});
const COMPUTER_PAGE_DESCRIPTION_MESSAGE = COMPUTER_DESCRIPTION_MESSAGES.computerPageDescriptionMessage;
const COMPUTER_TASK_DESCRIPTION_MESSAGE = COMPUTER_DESCRIPTION_MESSAGES.computerTaskDescriptionMessage;
export function getComputerStaticTitle(route, $t) {
    return $t(COMPUTER_TITLE_MESSAGES[route]);
}
function getComputerSkillsFallbackTitle($t) {
    return getComputerStaticTitle('/computer/skills', $t);
}
export function getComputerPageDescription($t) {
    return $t(COMPUTER_PAGE_DESCRIPTION_MESSAGE);
}
export function getComputerTaskDescription($t) {
    return $t(COMPUTER_TASK_DESCRIPTION_MESSAGE);
}
export function formatComputerSkillDocumentTitle(skillName, $t) {
    const fallbackTitle = getComputerSkillsFallbackTitle($t);
    const trimmedSkillName = skillName?.trim();
    return trimmedSkillName ? `${trimmedSkillName} - ${fallbackTitle}` : fallbackTitle;
}
//# sourceMappingURL=computerMetadataTitles.js.map